import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthProvider';
import { loginItemsSelector, setUserDetails, setUserDetailsError } from '../../redux/slices/login';
import { useDispatch, useSelector } from 'react-redux';
import Logo from '../../Asset/image/tamara_logo.png';
import sideImage from '../../Asset/image/header-img.png';
import emailIcon from '../../Asset/image/email.png';
import { Button, Col, Container, Form, FormLabel, Image, InputGroup, Row } from 'react-bootstrap';
import CustomImage from '../../CommonComponents/CustomImage';
import { toast } from 'react-toastify';
import { forgotPasswordService, loginService } from '../../services/userService';
import { errorMessage, isValiEmail } from '../../lib/helper';

const ForgotConfirmEmail = () => {
    /* @ts-ignore */
    const { user } = useAuth();
    const [validated, setValidated] = useState(false);
    const [state, setState] = useState({
        email: '',
        password: '',
        isSecureTextEntry: true,
    });
    const [isLoading, setLoader] = useState(false);
    const allUserState = useSelector(loginItemsSelector);
    const dispatch = useDispatch();
    const [error, setError] = useState({});

    const navigate = useNavigate();
    useEffect(() => {
        if (user) {
            dispatch(setUserDetails(user))
            navigate('/app/user-dashboard', { replace: true });
        }
    }, [user]);
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const sendForgotPasswordEmail = async () => {
        try {
            const params = {
                "email": state.email
            };
            setLoader(true);
            const response = await forgotPasswordService(params);
            if (response.status === 200) {
                navigate('/app/forgotpassword', { state: { email: state.email, route: true } })
                toast.success(response.data);
                setLoader(false);
                // showOTPView();
            } else {
                toast.error(response.data);
                setLoader(false)
            }
        } catch (e) {
            dispatch(
                setUserDetailsError({
                    isError: true,
                    message: errorMessage(e),
                }),
            );
            setLoader(false)
            toast.error(errorMessage(e), {
                autoClose: 2500,
            });
            return false
        }
    };
    const renderError = (msg, value, style) => {
        return (
            value ? (
                <h6 className="blog_error_text4 signUpMsg12" style={{ marginBottom: 10, marginTop: style !== undefined ? 10 : -10 }}>
                    {msg}
                </h6>) : null)
    }
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === false) {
            setValidated(false);
        } else {
            if (!isValiEmail(state.email)) {
                setError({ ...error, email: true })
            }
            else
                sendForgotPasswordEmail();
        }
        setValidated(true);
    };

    return (
        <>
            <div className="main-login-page backgroundColor" style={{ backgroundColor: " #060B19" }}>
                <Container fluid className="login-div">
                    <div className="login-container">
                        <CustomImage className="logo_style" src={Logo} />
                        <h2 className="App-header">Forgot Password</h2>
                        <p className="sub-header"> Please enter your email.</p>
                        <Form noValidate validated={validated} onSubmit={handleSubmit} >
                            <Row className='d-flex justify-content-center'>
                                <Form.Group as={Row} lg="4" xs="12" controlId="validationCustom01">
                                    <div className="wrapper w-100">
                                        <CustomImage className="icon" src={emailIcon} />
                                        <Form.Control
                                            required
                                            type="email"
                                            placeholder="Email"
                                            className="input-box px-5"
                                            defaultValue="Test@yopmail.com"
                                            value={state.email}
                                            onChange={(e) => { setState({ ...state, email: e.target.value }); setError({ ...error, email: false }) }}
                                        />
                                        <Form.Control.Feedback type="invalid">Please enter email!</Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                                {error.email ? renderError('Please enter valid email', true, false) : null}


                                <Button type='submit' className='login_button mt-4' disabled={isLoading}  >
                                    {isLoading ? (
                                        <div className='d-flex justify-content-center'>
                                            <center>
                                                <div
                                                    style={{ width: "1rem", height: "1rem", color: "#1f7e78" }}
                                                    class="spinner-border me-2 "
                                                    role="status"
                                                />
                                            </center>Submit
                                        </div>) : "Submit"}
                                </Button>
                            </Row>
                        </Form>
                    </div>
                    <div className="d-none d-lg-block" style={{
                        position: "absolute",
                        zIndex: 0,
                        height: '100vh',
                        width: '75vw',
                        right: 0
                    }}>
                        <CustomImage className="w-100" src={sideImage} />
                    </div>
                </Container>
            </div >
        </>
    );
};

export default ForgotConfirmEmail;
